"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPastePluginSetting = getPastePluginSetting;

var _utils = require("../utils");

var _hspaste = require("../constants/hspaste");

function getPastePluginSetting(editor, setting) {
  var pastePluginSettings = (0, _utils.getPluginSetting)(editor, _hspaste.PASTE_SETTINGS);

  if (pastePluginSettings) {
    return pastePluginSettings[setting];
  }

  return null;
}